(function () {
  'use strict';

  var storageKey = 'coollightsCompareProductsV1';
  var maximumProducts = 4;
  var selectedProducts = [];
  var lastFocusedElement = null;

  function safelyParse(value, fallback) {
    try {
      return JSON.parse(value || '');
    } catch (error) {
      return fallback;
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function readStoredProducts() {
    try {
      var stored = safelyParse(window.localStorage.getItem(storageKey), []);
      if (!Array.isArray(stored)) return [];
      return stored.filter(function (product) {
        return product && product.id && product.title;
      }).slice(0, maximumProducts);
    } catch (error) {
      return [];
    }
  }

  function saveProducts() {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(selectedProducts));
    } catch (error) {
      // Comparison still works for this page when storage is unavailable.
    }
  }

  function productFromButton(button) {
    return {
      id: button.getAttribute('data-product-id') || '',
      title: button.getAttribute('data-product-title') || '',
      url: button.getAttribute('data-product-url') || '#',
      image: button.getAttribute('data-product-image') || '',
      price: button.getAttribute('data-product-price') || '',
      vendor: button.getAttribute('data-product-vendor') || '',
      type: button.getAttribute('data-product-type') || '',
      availability: button.getAttribute('data-product-availability') || '',
      options: safelyParse(button.getAttribute('data-product-options'), []),
      specs: safelyParse(button.getAttribute('data-product-specs'), [])
    };
  }

  function selectedIndex(productId) {
    for (var index = 0; index < selectedProducts.length; index += 1) {
      if (String(selectedProducts[index].id) === String(productId)) return index;
    }
    return -1;
  }

  function announce(message) {
    var region = document.querySelector('[data-compare-announcement]');
    if (region) region.textContent = message;
  }

  function toggleProduct(button) {
    var product = productFromButton(button);
    var index = selectedIndex(product.id);

    if (index >= 0) {
      selectedProducts.splice(index, 1);
      announce(product.title + ' removed from comparison.');
    } else if (selectedProducts.length >= maximumProducts) {
      announce('You can compare up to ' + maximumProducts + ' products. Remove one before adding another.');
      return;
    } else {
      selectedProducts.push(product);
      announce(product.title + ' added to comparison.');
    }

    saveProducts();
    render();
  }

  function removeProduct(productId) {
    var index = selectedIndex(productId);
    if (index < 0) return;
    var removedTitle = selectedProducts[index].title;
    selectedProducts.splice(index, 1);
    saveProducts();
    announce(removedTitle + ' removed from comparison.');
    render();
  }

  function updateProductButtons() {
    var buttons = document.querySelectorAll('[data-compare-product]');
    Array.prototype.forEach.call(buttons, function (button) {
      var isSelected = selectedIndex(button.getAttribute('data-product-id')) >= 0;
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      var label = button.querySelector('[data-compare-label]');
      if (label) label.textContent = isSelected ? 'Remove from compare' : 'Compare';
    });
  }

  function renderBar() {
    var bar = document.getElementById('coollights-compare-bar');
    if (!bar) return;

    bar.hidden = selectedProducts.length === 0;
    var summary = bar.querySelector('[data-compare-summary]');
    if (summary) {
      summary.textContent = selectedProducts.length < 2
        ? selectedProducts.length + ' selected — add one more.'
        : selectedProducts.length + ' of ' + maximumProducts + ' selected.';
    }

    var items = bar.querySelector('[data-compare-items]');
    if (items) {
      items.innerHTML = selectedProducts.map(function (product) {
        return '<div class="coollights-compare-chip">' +
          (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '') +
          '<span>' + escapeHtml(product.title) + '</span>' +
          '<button type="button" data-compare-remove="' + escapeHtml(product.id) + '" aria-label="Remove ' + escapeHtml(product.title) + '">&times;</button>' +
        '</div>';
      }).join('');
    }

    var openButton = bar.querySelector('[data-compare-open]');
    if (openButton) openButton.disabled = selectedProducts.length < 2;
  }

  function collectLabels(property) {
    var labels = [];
    selectedProducts.forEach(function (product) {
      var items = Array.isArray(product[property]) ? product[property] : [];
      items.forEach(function (item) {
        if (item && item.label && labels.indexOf(String(item.label)) < 0) labels.push(String(item.label));
      });
    });
    return labels;
  }

  function itemValue(product, property, label) {
    var items = Array.isArray(product[property]) ? product[property] : [];
    for (var index = 0; index < items.length; index += 1) {
      if (String(items[index].label) === label) return items[index].value || '—';
    }
    return '—';
  }

  function isDifferent(values) {
    var normalized = values.map(function (value) {
      return String(value == null ? '' : value).replace(/\s+/g, ' ').trim().toLowerCase();
    });
    return normalized.filter(function (value, index) {
      return normalized.indexOf(value) === index;
    }).length > 1;
  }

  function comparisonRow(label, values) {
    var rowClass = isDifferent(values) ? 'is-different' : 'is-same';
    return '<tr class="' + rowClass + '"><th scope="row">' + escapeHtml(label) + '</th>' +
      values.map(function (value) { return '<td>' + escapeHtml(value || '—') + '</td>'; }).join('') +
    '</tr>';
  }

  function renderTable() {
    var container = document.querySelector('[data-compare-table]');
    if (!container || selectedProducts.length < 2) return;

    var header = '<tr><th scope="col">Feature</th>' + selectedProducts.map(function (product) {
      return '<th scope="col"><div class="coollights-compare-product">' +
        (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '') +
        '<a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a>' +
      '</div></th>';
    }).join('') + '</tr>';

    var rows = '';
    rows += comparisonRow('Price', selectedProducts.map(function (product) { return product.price; }));
    rows += comparisonRow('Availability', selectedProducts.map(function (product) { return product.availability; }));
    rows += comparisonRow('Brand', selectedProducts.map(function (product) { return product.vendor; }));
    rows += comparisonRow('Product type', selectedProducts.map(function (product) { return product.type; }));

    collectLabels('options').forEach(function (label) {
      rows += comparisonRow(label, selectedProducts.map(function (product) { return itemValue(product, 'options', label); }));
    });
    collectLabels('specs').forEach(function (label) {
      rows += comparisonRow(label, selectedProducts.map(function (product) { return itemValue(product, 'specs', label); }));
    });

    container.innerHTML = '<table class="coollights-compare-table"><thead>' + header + '</thead><tbody>' + rows + '</tbody></table>';
    updateDifferenceFilter();
  }

  function updateDifferenceFilter() {
    var checkbox = document.querySelector('[data-compare-differences]');
    var table = document.querySelector('.coollights-compare-table');
    if (!checkbox || !table) return;
    table.classList.toggle('show-differences-only', checkbox.checked);
  }

  function openModal(trigger) {
    if (selectedProducts.length < 2) return;
    var modal = document.getElementById('coollights-compare-modal');
    if (!modal) return;
    lastFocusedElement = trigger || document.activeElement;
    renderTable();
    modal.hidden = false;
    document.body.classList.add('coollights-compare-open');
    var closeButton = modal.querySelector('.coollights-compare-modal__close');
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    var modal = document.getElementById('coollights-compare-modal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('coollights-compare-open');
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') lastFocusedElement.focus();
  }

  function render() {
    updateProductButtons();
    renderBar();
    if (selectedProducts.length >= 2) {
      renderTable();
    } else {
      closeModal();
    }
  }

  function bindEvents() {
    document.addEventListener('click', function (event) {
      var productButton = event.target.closest('[data-compare-product]');
      if (productButton) {
        event.preventDefault();
        toggleProduct(productButton);
        return;
      }

      var removeButton = event.target.closest('[data-compare-remove]');
      if (removeButton) {
        removeProduct(removeButton.getAttribute('data-compare-remove'));
        return;
      }

      var openButton = event.target.closest('[data-compare-open]');
      if (openButton) {
        openModal(openButton);
        return;
      }

      if (event.target.closest('[data-compare-clear]')) {
        selectedProducts = [];
        saveProducts();
        announce('Product comparison cleared.');
        render();
        return;
      }

      if (event.target.closest('[data-compare-close]')) closeModal();
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-compare-differences]')) updateDifferenceFilter();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeModal();
    });
  }

  function initialize() {
    selectedProducts = readStoredProducts();
    bindEvents();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
}());